const generateMailtoLink = ({ to, subject, body }) =>
  `mailto:${to || ""}?subject=${subject}&body=${body}`;

export default generateMailtoLink;
